import { ComponentProps } from 'react'
import { CompositeComponent } from 'lib'
import { Typography } from '../Typography'
import { h1, h2, h3, h4, h5, hero } from './Heading.css'

type HeadingVariant = 'Hero' | 'H1' | 'H2' | 'H3' | 'H4' | 'H5'
type Props = Omit<ComponentProps<typeof Typography>, 'component'>

export const Heading: CompositeComponent<Props, HeadingVariant, Props> = ({ children, ...props }) => (
	<Typography {...props}>{children}</Typography>
)

Heading.Hero = ({ children, ...props }) => (
	<Typography component={'h1'} className={hero} {...props}>
		{children}
	</Typography>
)
Heading.H1 = ({ children, ...props }) => (
	<Typography component={'h1'} className={h1} {...props}>
		{children}
	</Typography>
)
Heading.H2 = ({ children, ...props }) => (
	<Typography component={'h2'} className={h2} {...props}>
		{children}
	</Typography>
)
Heading.H3 = ({ children, ...props }) => (
	<Typography component={'h3'} className={h3} {...props}>
		{children}
	</Typography>
)
Heading.H4 = ({ children, ...props }) => (
	<Typography component={'h4'} className={h4} {...props}>
		{children}
	</Typography>
)
Heading.H5 = ({ children, ...props }) => (
	<Typography component={'h5'} className={h5} {...props}>
		{children}
	</Typography>
)
